'use client';

import type { ComponentProps } from 'react';

import dynamic from 'next/dynamic';

import type { ImageLightbox as ImageLightboxType } from '@/components/ui/image-lightbox';

const ImageLightbox = dynamic(
  () => import('@/components/ui/image-lightbox').then(mod => ({ default: mod.ImageLightbox })),
  { ssr: false },
);

type LazyImageLightboxProps = ComponentProps<typeof ImageLightboxType>;

export function LazyImageLightbox(props: LazyImageLightboxProps) {
  if (!props.open) {
    return null;
  }
  return <ImageLightbox {...props} />;
}

export { useImageLightbox } from '@/components/ui/image-lightbox';
